/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-unused-prop-types */
import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'

import { Button, Input } from '@mui/material'
import { SearchOutlined } from '@mui/icons-material'
import FilterListIcon from '@mui/icons-material/FilterList'
import ExportButton from 'components/ExportButton'
import { WAITING_CLARIFICATION_VALUES } from 'utils/constants/application'
import AdvancedFiltersPopover from './AdvancedFiltersPopover'
import styles from './styles'

const SearchBar = (props) => {
  const { searchParams, setSearchParams } = props
  const filtersInitialValues = {
    initDate: '',
    endDate: '',
    status: 'ALL',
    result: 'ALL',
    showWaitingClarification: 'ALL',
    showEmptyApplications: false,
    searchTerm: '',
  }
  const [searchText, setSearchText] = useState('')
  const [filterValues, setFilterValues] = useState(filtersInitialValues)
  const isFirstRender = useRef(true)
  const [popoverAnchorEl, setAdvancedFiltersPopoverAnchorEl] = useState(null)
  const [advancedFiltersPopoverOpen, setAdvancedFiltersPopoverOpen] = useState(false)

  const classes = styles()

  const getSearchField = (userInput) => {
    const cpfRegex = new RegExp('^[0-9.-]*$')

    if (cpfRegex.test(userInput.toLowerCase())) {
      return 'candidate_cpf'
    }
    return 'candidate_name'
  }

  const handleSearch = () => {
    const { initDate, endDate, status, result, showEmptyApplications, showWaitingClarification, searchTerm } =
      filterValues
    const searchParam = {
      start_date: initDate !== '' ? initDate : undefined,
      final_date: endDate !== '' ? endDate : undefined,
      status: status !== 'ALL' ? status : undefined,
      result: result !== 'ALL' ? result : undefined,
      waiting_clarification: WAITING_CLARIFICATION_VALUES[showWaitingClarification],
      hide_empty_applications: !showEmptyApplications,
    }
    if (searchTerm !== '') {
      const field = getSearchField(searchTerm)
      searchParam[field] = searchTerm
    }

    setSearchParams(searchParam)
  }
  const changeFilterValue = (newValues = {}) => {
    setFilterValues({ ...filterValues, ...newValues })
  }

  const handleSubmitSearch = () => {
    changeFilterValue({ searchTerm: searchText })
  }

  const handleOnChangeSearchText = (event) => {
    setSearchText(event.target.value)
  }

  const handleEnter = (event) => {
    if (event.keyCode === 13) {
      event.preventDefault()
      handleSubmitSearch()
    }
    return false
  }

  const handleClickAdvancedFiltering = (event) => {
    setAdvancedFiltersPopoverAnchorEl(event.currentTarget)
    setAdvancedFiltersPopoverOpen(!advancedFiltersPopoverOpen)
  }

  const onClonseAdvancedFiltersPopover = () => {
    setAdvancedFiltersPopoverAnchorEl(null)
    setAdvancedFiltersPopoverOpen(!advancedFiltersPopoverOpen)
  }

  useEffect(() => {
    handleSearch()
  }, [filterValues])

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false
      return
    }
    if (searchText === '') {
      changeFilterValue({ searchTerm: searchText })
    }
  }, [searchText])

  return (
    <React.Fragment>
      <div className={classes.leftSide}>
        <Button className={classes.leftSideButton} onClick={handleSubmitSearch}>
          <SearchOutlined />
        </Button>
        <Input
          className={classes.txtField}
          type="search"
          placeholder="Digite o nome ou CPF do candidato"
          value={searchText}
          onChange={handleOnChangeSearchText}
          onKeyUp={handleEnter}
        />
        <Button
          variant="outlined"
          className={classes.filterButton}
          startIcon={<FilterListIcon />}
          onClick={handleClickAdvancedFiltering}
        >
          Filtros
        </Button>
        <AdvancedFiltersPopover
          anchorEl={popoverAnchorEl}
          open={advancedFiltersPopoverOpen}
          onClose={onClonseAdvancedFiltersPopover}
          filterValues={filterValues}
          changeFilterValue={changeFilterValue}
        />
      </div>
      <div className={classes.rightSide}>
        <ExportButton url="/applications/export" searchParams={searchParams} filename="lista-de-aplicacoes" />
      </div>
    </React.Fragment>
  )
}

SearchBar.propTypes = {
  setSearchParams: PropTypes.func.isRequired,
}

export default SearchBar
